import { fetchProfile, fetchAlarmList } from "@/api/index";

const actions = {
  /**
   * LOGIN
   */
  LOGIN({ commit }, data) {
    commit("LOGIN", data);
    commit("SET_USER_INFO", data);
  },
  /*
   * LOGOUT
   */
  LOGOUT({ commit }) {
    commit("LOGOUT");
    window.location.href = "/";
  },

  /**
   * fetch User 정보
   */
  getAccountInfo({ commit, dispatch }) {
    fetchProfile().then((res) => {
      if (res.data.status == 200 && res.data.data) {
        let data = {
          userId: res.data.data._id,
          email: res.data.data.email,
          week: res.data.data.week,
          day: res.data.data.day,
          isAdmin: res.data.data.isAdmin,
          username: res.data.data.username,
          weddingHall: res.data.data.weddingHall,
          mobileNo: res.data.data.mobileNo,
        };
        commit("SET_USER_INFO", data);
      } else {
        dispatch("LOGOUT");
        throw new Error("사용자 정보를 가져올 수 없습니다.");
      }
    });
  },

  getNewAlarm({ commit }) {
    fetchAlarmList().then((res) => {
      if (res.data.status == 200) {
        let data = res.data.count;
        commit("SET_ALARMCOUNT", data);
      } else {
        let message = res.data.message;
        alert(message);
      }
    });
  },
  SET_NAVBAR({ commit }, data) {
    commit("SET_NAVBAR", data);
  },
  SET_ADMINNAVBAR({ commit }, data) {
    commit("SET_ADMINNAVBAR", data);
  },
  SET_NAVBAR_VISIBLE({ commit }, data) {
    commit("SET_NAVBAR_VISIBLE", data);
  },
  SET_USERNAME({ commit }, data) {
    commit("SET_USERNAME", data);
  },
  SET_MOBILENO({ commit }, data) {
    commit("SET_MOBILENO", data);
  },
  SET_USER_INFO({ commit }, data) {
    commit("SET_USER_INFO", data);
  },
  SET_FOOTER_VISIBLE({ commit }, data) {
    commit("SET_FOOTER_VISIBLE", data);
  },
  SET_LNB_VISIBLE({ commit }, data) {
    commit("SET_LNB_VISIBLE", data);
  },
  SET_ADMINLNB_VISIBLE({ commit }, data) {
    commit("SET_ADMINLNB_VISIBLE", data);
  },
  SET_ADMINGNB_VISIBLE({ commit }, data) {
    commit("SET_ADMINGNB_VISIBLE", data);
  },
  SET_GNB_VISIBLE({ commit }, data) {
    commit("SET_GNB_VISIBLE", data);
  },
  SET_ALARMCOUNT({ commit }, data) {
    commit("SET_ALARMCOUNT", data);
  },
  SET_MENU_COLLAPSE({ commit }, data) {
    commit("SET_MENU_COLLAPSE", data);
  },
};

export default actions;
